import { NgModuleRef } from '@angular/core';
import { disableDebugTools } from '@angular/platform-browser';

import { Environment } from './model';

export const environment: Environment = {
    production: true,
    development: false,
    timeOutSecond: 30,
    resetPasswordUrl: 'http://localhost:4200/#/reset/request',
    version: '2025-5-25.1_12',
    appUrl: 'https://live.mersys.io',
    uaaUrl: 'https://uaa.mersys.io',
    testUrl: 'https://test.mersys.io',
    website: 'https://mersys.io',
    useCaptcha: false,
    traceErrorLog: false,
    logo: 'assets/images/logos/logo_main.avif',
    logoWidth: 256,
    wsId: 'test',
    wsApiKey: '48aec37abfcbc9b8f65e1706f4c711583a8b01f2d3027c6e8baa02779ba27992',
    serverInfo: undefined,
    injector: undefined,
    timezoneOffset: -1,
    decorateModuleRef(modRef: NgModuleRef<any>) {
        disableDebugTools();
        return modRef;
    },
};
